@if (assetKey === 'logo') {
  <svg
    class="responsive-svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 250 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4942_7042)">
      <rect width="300" height="300" rx="5" fill="white" />
      <g filter="url(#filter0_d_4942_7042)">
        <mask
          id="mask0_4942_7042"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="24"
          y="16"
          width="339"
          height="705"
        >
          <path
            d="M321.212 16H65.3689C42.8364 16 24.5703 33.8452 24.5703 55.8583V680.549C24.5703 702.562 42.8364 720.408 65.3689 720.408H321.212C343.745 720.408 362.011 702.562 362.011 680.549V55.8583C362.011 33.8452 343.745 16 321.212 16Z"
            fill="url(#paint0_linear_4942_7042)"
          />
        </mask>
        <g mask="url(#mask0_4942_7042)">
          <path
            d="M321.212 16H65.3689C42.8364 16 24.5703 33.8452 24.5703 55.8583V680.549C24.5703 702.562 42.8364 720.408 65.3689 720.408H321.212C343.745 720.408 362.011 702.562 362.011 680.549V55.8583C362.011 33.8452 343.745 16 321.212 16Z"
            fill="#C0CFC7"
          />
          <path
            d="M321.212 16H65.3689C42.8364 16 24.5703 33.8452 24.5703 55.8583V680.549C24.5703 702.562 42.8364 720.408 65.3689 720.408H321.212C343.745 720.408 362.011 702.562 362.011 680.549V55.8583C362.011 33.8452 343.745 16 321.212 16Z"
            [attr.fill]="assetMainColor || 'white'"
          />
          <rect
            opacity="0.7"
            x="63.2324"
            y="150.481"
            width="54.1541"
            height="9.21772"
            rx="4.60886"
            fill="url(#paint1_linear_4942_7042)"
          />
          <rect
            opacity="0.7"
            x="63.2324"
            y="279.529"
            width="54.1541"
            height="9.21772"
            rx="4.60886"
            fill="url(#paint2_linear_4942_7042)"
          />
          <rect
            opacity="0.7"
            x="166.932"
            y="150.481"
            width="54.1541"
            height="9.21772"
            rx="4.60886"
            fill="url(#paint3_linear_4942_7042)"
          />
          <rect
            opacity="0.7"
            x="166.932"
            y="279.529"
            width="54.1541"
            height="9.21772"
            rx="4.60886"
            fill="url(#paint4_linear_4942_7042)"
          />
          <rect
            opacity="0.7"
            x="270.631"
            y="150.481"
            width="54.1541"
            height="9.21772"
            rx="4.60886"
            fill="url(#paint5_linear_4942_7042)"
          />
          <rect
            opacity="0.7"
            x="270.631"
            y="279.529"
            width="54.1541"
            height="9.21772"
            rx="4.60886"
            fill="url(#paint6_linear_4942_7042)"
          />
          <rect
            x="57.4707"
            y="205.786"
            width="63.3718"
            height="63.3718"
            rx="17.2832"
            fill="#FCFCFC"
          />
          <rect
            x="263.719"
            y="76.7383"
            width="63.3718"
            height="63.3718"
            rx="17.2832"
            fill="#FCFCFC"
          />
          <rect
            x="161.17"
            y="76.7383"
            width="63.3718"
            height="63.3718"
            rx="17.2832"
            fill="#FCFCFC"
          />
          <rect
            x="262.566"
            y="205.786"
            width="63.3718"
            height="63.3718"
            rx="17.2832"
            fill="#FCFCFC"
          />
          <rect
            x="161.279"
            y="205.786"
            width="63.3718"
            height="63.3718"
            rx="17.2832"
            fill="#FCFCFC"
          />
          <g filter="url(#filter1_d_4942_7042)">
            <rect
              x="56.3675"
              y="76.2454"
              width="65.5626"
              height="65.5626"
              rx="18.3786"
              fill="white"
              stroke="white"
              stroke-width="2.19077"
            />
            <!-- logo image -->
            <clipPath id="roundedLogoCorners">
              <rect x="58.5583" y="78.4362" width="61.1811" height="61.1811" rx="16.7" />
            </clipPath>
            <image
              [attr.xlink:href]="logoURL$ | async"
              x="58.5583"
              y="78.4362"
              width="61.1811"
              height="61.1811"
              preserveAspectRatio="xMidYMid slice"
              clip-path="url(#roundedLogoCorners)"
            />
          </g>
          <path
            d="M56.4124 49.4023C56.2054 49.4023 56.0344 49.3394 55.8994 49.2134C55.7645 49.0784 55.697 48.9119 55.697 48.714V41.4792L55.8724 41.7222L54.6172 42.5995C54.5092 42.6895 54.3787 42.7345 54.2257 42.7345C54.0458 42.7345 53.8838 42.667 53.7398 42.532C53.6048 42.3881 53.5374 42.2216 53.5374 42.0326C53.5374 41.7987 53.6543 41.6052 53.8883 41.4522L55.9399 40.089C56.0209 40.035 56.1064 39.999 56.1964 39.981C56.2954 39.963 56.3854 39.954 56.4663 39.954C56.6733 39.954 56.8398 40.0215 56.9658 40.1565C57.0917 40.2824 57.1547 40.4444 57.1547 40.6424V48.714C57.1547 48.9119 57.0827 49.0784 56.9388 49.2134C56.8038 49.3394 56.6283 49.4023 56.4124 49.4023ZM64.6704 48.1471C64.8503 48.1471 64.9988 48.2101 65.1158 48.336C65.2418 48.453 65.3048 48.6015 65.3048 48.7815C65.3048 48.9614 65.2418 49.1099 65.1158 49.2269C64.9988 49.3439 64.8503 49.4023 64.6704 49.4023H59.9327C59.7347 49.4023 59.5773 49.3439 59.4603 49.2269C59.3433 49.1099 59.2848 48.9524 59.2848 48.7545C59.2848 48.5745 59.3478 48.4125 59.4738 48.2685L62.4838 45.0156C62.8707 44.6017 63.1676 44.1923 63.3746 43.7873C63.5906 43.3824 63.6985 43.027 63.6985 42.721C63.6985 42.2261 63.5501 41.8257 63.2531 41.5197C62.9562 41.2138 62.5647 41.0608 62.0788 41.0608C61.8719 41.0608 61.6604 41.1103 61.4444 41.2093C61.2375 41.2993 61.0395 41.4252 60.8505 41.5872C60.6706 41.7402 60.5131 41.9202 60.3781 42.1271C60.2881 42.2531 60.1982 42.3341 60.1082 42.3701C60.0182 42.4061 59.9327 42.4241 59.8517 42.4241C59.6807 42.4241 59.5233 42.3656 59.3793 42.2486C59.2443 42.1226 59.1768 41.9786 59.1768 41.8167C59.1768 41.6907 59.2173 41.5692 59.2983 41.4522C59.3793 41.3353 59.4828 41.2138 59.6088 41.0878C59.8067 40.8448 60.0452 40.6289 60.3241 40.4399C60.6121 40.242 60.9135 40.089 61.2285 39.981C61.5434 39.873 61.8539 39.819 62.1598 39.819C62.7537 39.819 63.2666 39.936 63.6985 40.17C64.1395 40.4039 64.4769 40.7324 64.7109 41.1553C64.9538 41.5782 65.0753 42.0776 65.0753 42.6535C65.0753 43.1394 64.9268 43.6793 64.6299 44.2732C64.3419 44.8581 63.937 45.434 63.4151 46.0009L61.323 48.282L61.1745 48.1471H64.6704ZM67.619 44.0033C67.394 44.0033 67.2185 43.9448 67.0926 43.8278C66.9756 43.7018 66.9171 43.5264 66.9171 43.3014V43.045C66.9171 42.82 66.9756 42.6445 67.0926 42.5186C67.2185 42.3926 67.394 42.3296 67.619 42.3296H67.7674C67.9924 42.3296 68.1634 42.3926 68.2804 42.5186C68.3973 42.6445 68.4558 42.82 68.4558 43.045V43.3014C68.4558 43.5264 68.3973 43.7018 68.2804 43.8278C68.1634 43.9448 67.9924 44.0033 67.7674 44.0033H67.619ZM67.619 49.4023C67.394 49.4023 67.2185 49.3394 67.0926 49.2134C66.9756 49.0874 66.9171 48.9119 66.9171 48.687V48.444C66.9171 48.2101 66.9756 48.0346 67.0926 47.9176C67.2185 47.7916 67.394 47.7286 67.619 47.7286H67.7674C67.9924 47.7286 68.1634 47.7916 68.2804 47.9176C68.3973 48.0346 68.4558 48.2101 68.4558 48.444V48.687C68.4558 48.9119 68.3973 49.0874 68.2804 49.2134C68.1634 49.3394 67.9924 49.4023 67.7674 49.4023H67.619ZM74.4912 49.4023C74.3022 49.4023 74.1447 49.3394 74.0187 49.2134C73.8928 49.0784 73.8298 48.9119 73.8298 48.714V41.8437L74.0727 41.9247L71.1572 45.65L71.0898 45.4745H76.0029C76.1829 45.4745 76.3313 45.5375 76.4483 45.6635C76.5743 45.7805 76.6373 45.929 76.6373 46.1089C76.6373 46.2799 76.5743 46.4239 76.4483 46.5408C76.3313 46.6578 76.1829 46.7163 76.0029 46.7163H70.1584C69.9965 46.7163 69.8435 46.6533 69.6995 46.5273C69.5555 46.3924 69.4835 46.2349 69.4835 46.0549C69.4835 45.884 69.542 45.731 69.659 45.596L73.9513 40.224C74.0142 40.134 74.0952 40.0665 74.1942 40.0215C74.2932 39.9765 74.3967 39.954 74.5047 39.954C74.7026 39.954 74.8646 40.0215 74.9906 40.1565C75.1166 40.2824 75.1795 40.4444 75.1795 40.6424V48.714C75.1795 48.9119 75.1121 49.0784 74.9771 49.2134C74.8421 49.3394 74.6801 49.4023 74.4912 49.4023ZM80.2589 49.4968C79.9079 49.4968 79.5435 49.4428 79.1656 49.3349C78.7966 49.2269 78.4817 49.0649 78.2207 48.8489C78.1217 48.768 78.0453 48.6645 77.9913 48.5385C77.9373 48.4125 77.9103 48.291 77.9103 48.1741C77.9103 48.0481 77.9643 47.9266 78.0723 47.8096C78.1892 47.6836 78.3467 47.6207 78.5447 47.6207C78.6886 47.6207 78.8551 47.6926 79.0441 47.8366C79.224 47.9536 79.413 48.0526 79.611 48.1336C79.8179 48.2146 80.0294 48.255 80.2454 48.255C80.7133 48.255 81.1182 48.1696 81.4602 47.9986C81.8021 47.8276 82.0631 47.5892 82.243 47.2832C82.432 46.9683 82.5265 46.6038 82.5265 46.1899C82.5265 45.803 82.441 45.4745 82.27 45.2046C82.099 44.9256 81.8651 44.7097 81.5681 44.5567C81.2802 44.4037 80.9562 44.3272 80.5963 44.3272C80.2994 44.3272 80.0384 44.3767 79.8134 44.4757C79.5885 44.5657 79.386 44.6602 79.2061 44.7592C79.0261 44.8491 78.8596 44.8941 78.7066 44.8941C78.4727 44.8941 78.2972 44.8446 78.1802 44.7457C78.0633 44.6377 77.9868 44.5117 77.9508 44.3677C77.9238 44.2148 77.9193 44.0753 77.9373 43.9493L78.4097 40.5614C78.4367 40.4084 78.5087 40.2824 78.6257 40.1835C78.7516 40.0755 78.9046 40.0215 79.0846 40.0215H83.0394C83.2193 40.0215 83.3678 40.0845 83.4848 40.2105C83.6108 40.3274 83.6738 40.4759 83.6738 40.6559C83.6738 40.8358 83.6108 40.9843 83.4848 41.1013C83.3678 41.2183 83.2193 41.2768 83.0394 41.2768H79.422L79.5705 41.1553L79.1386 44.0573L78.9361 43.6524C79.0171 43.5624 79.1521 43.4769 79.341 43.3959C79.539 43.3059 79.7595 43.2339 80.0024 43.1799C80.2544 43.1169 80.5063 43.0855 80.7583 43.0855C81.3522 43.0855 81.8831 43.2204 82.351 43.4904C82.8279 43.7513 83.2014 44.1158 83.4713 44.5837C83.7413 45.0516 83.8762 45.5825 83.8762 46.1764C83.8762 46.8423 83.7278 47.4272 83.4308 47.9311C83.1339 48.426 82.7154 48.8129 82.1755 49.0919C81.6356 49.3619 80.9967 49.4968 80.2589 49.4968Z"
            fill="black"
          />
        </g>
      </g>
      <path
        d="M318.562 16H68.0263C39.4851 16 16.1348 39.0438 16.1348 67.2155V676.784C16.1348 704.95 39.4851 728 68.0263 728H318.562C347.097 728 370.448 704.95 370.448 676.784V67.2155C370.448 39.0438 347.097 16 318.562 16ZM358.683 676.784C358.683 698.62 340.685 716.385 318.562 716.385H68.0263C45.9037 716.385 27.8993 698.62 27.8993 676.784V67.2155C27.8993 45.3797 45.9037 27.6148 68.0263 27.6148H108.141C109.145 33.9756 112.45 39.7767 117.461 43.9691C122.472 48.1615 128.856 50.4684 135.461 50.4728H251.08C257.691 50.4721 264.083 48.1648 269.098 43.9687C274.114 39.7725 277.422 33.9648 278.423 27.5974H318.538C340.661 27.5974 358.659 45.3623 358.659 67.1981L358.683 676.784Z"
        fill="black"
      />
      <path
        d="M287.615 41.2176V48.9858H286.42V41.2176H287.615ZM288.512 40.3213H285.524V49.8821H288.512V40.3213ZM284.329 43.309H281.341V49.8821H284.329V43.309ZM280.146 46.2968H277.158V49.8821H280.146V46.2968Z"
        fill="black"
      />
      <g clip-path="url(#clip1_4942_7042)">
        <path
          d="M298.426 42.9939L299.48 44.1187C302.101 41.3236 306.35 41.3236 308.971 44.1187L310.025 42.9939C306.825 39.5801 301.631 39.5801 298.426 42.9939ZM302.644 47.4931L304.226 49.1803L305.807 47.4931C305.6 47.2712 305.353 47.0951 305.082 46.975C304.81 46.8548 304.519 46.793 304.226 46.793C303.932 46.793 303.641 46.8548 303.369 46.975C303.098 47.0951 302.851 47.2712 302.644 47.4931ZM300.535 45.2435L301.589 46.3683C302.289 45.6229 303.237 45.2042 304.226 45.2042C305.214 45.2042 306.162 45.6229 306.862 46.3683L307.916 45.2435C305.881 43.0727 302.575 43.0727 300.535 45.2435Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_4942_7042"
        x="-34.4818"
        y="-43.0521"
        width="472.418"
        height="839.384"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8.43602" dy="8.43602" />
        <feGaussianBlur stdDeviation="33.7441" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4942_7042"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4942_7042"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_4942_7042"
        x="25.2094"
        y="45.0883"
        width="127.878"
        height="127.877"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15.031" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4942_7042"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4942_7042"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4942_7042"
        x1="46.493"
        y1="16.3254"
        x2="331.66"
        y2="725.648"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF9150" />
        <stop offset="1" stop-color="#FF4757" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4942_7042"
        x1="63.2324"
        y1="150.481"
        x2="66.282"
        y2="168.398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4942_7042"
        x1="63.2324"
        y1="279.529"
        x2="66.282"
        y2="297.446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4942_7042"
        x1="166.932"
        y1="150.481"
        x2="169.981"
        y2="168.398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4942_7042"
        x1="166.932"
        y1="279.529"
        x2="169.981"
        y2="297.446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_4942_7042"
        x1="270.631"
        y1="150.481"
        x2="273.68"
        y2="168.398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_4942_7042"
        x1="270.631"
        y1="279.529"
        x2="273.68"
        y2="297.446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <clipPath id="clip0_4942_7042">
        <rect width="300" height="300" rx="5" fill="white" />
      </clipPath>
      <clipPath id="clip1_4942_7042">
        <rect
          width="12.654"
          height="13.4976"
          fill="white"
          transform="translate(297.896 37.9326)"
        />
      </clipPath>
    </defs>
  </svg>
}
@if (assetKey === 'iconTv') {
  <svg
    class="responsive-svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4942_7105)">
      <rect width="300" height="300" rx="5" fill="white" />
      <rect
        x="18.3814"
        y="-123.494"
        width="606.034"
        height="383.125"
        rx="10.4489"
        [attr.fill]="assetMainColor || 'white'"
        stroke="#252525"
        stroke-width="6.96591"
      />
      <rect
        opacity="0.5"
        x="47.4043"
        y="-94.4668"
        width="662.698"
        height="141.602"
        rx="11.3282"
        fill="white"
      />
      <path
        d="M107.771 279.367L117.059 263.113L121.703 290.977"
        stroke="#252525"
        stroke-width="6.96591"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <!-- <rect
        x="47.4043"
        y="69.7891"
        width="96.2895"
        height="60"
        rx="11.3282"
        fill="white"
      /> -->
      <!-- Fills the rectangle with an image -->
      <clipPath id="roundedImageCorners1">
        <rect x="47.4043" y="69.7891" width="96.2895" height="60" rx="11.3282" />
      </clipPath>
      <image
        [attr.xlink:href]="iconTvURL$ | async"
        x="47.4043"
        y="69.7891"
        width="96.2895"
        height="60"
        preserveAspectRatio="xMidYMid slice"
        clip-path="url(#roundedImageCorners1)"
      />
      <rect
        opacity="0.3"
        x="67.5977"
        y="136.671"
        width="55.2225"
        height="5.66408"
        rx="2.83204"
        fill="url(#paint0_linear_4942_7105)"
      />
      <rect
        x="160.686"
        y="69.7891"
        width="96.2894"
        height="60"
        rx="11.3282"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="179.666"
        y="136.671"
        width="55.7977"
        height="5.66408"
        rx="2.83204"
        fill="url(#paint1_linear_4942_7105)"
      />
      <rect
        x="273.967"
        y="69.7891"
        width="96.2894"
        height="60"
        rx="11.3282"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="293.502"
        y="136.671"
        width="55.7977"
        height="5.66408"
        rx="2.83204"
        fill="url(#paint2_linear_4942_7105)"
      />
      <g filter="url(#filter0_d_4942_7105)">
        <rect x="47.4043" y="166.078" width="100" height="60" rx="11.3282" fill="white" />
      </g>
      <rect
        opacity="0.3"
        x="68.4707"
        y="233.537"
        width="57.7737"
        height="5.66408"
        rx="2.83204"
        fill="url(#paint3_linear_4942_7105)"
      />
      <rect x="164.396" y="166.078" width="100" height="60" rx="11.3282" fill="white" />
      <rect
        opacity="0.3"
        x="184.736"
        y="233.537"
        width="57.7737"
        height="5.66408"
        rx="2.83204"
        fill="url(#paint4_linear_4942_7105)"
      />
      <rect x="281.389" y="166.078" width="100" height="60" rx="11.3282" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_4942_7105"
        x="24.748"
        y="143.422"
        width="145.313"
        height="105.313"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="11.3282" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4942_7105"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4942_7105"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4942_7105"
        x1="67.5977"
        y1="136.671"
        x2="68.7475"
        y2="147.881"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4942_7105"
        x1="179.666"
        y1="136.671"
        x2="180.804"
        y2="147.884"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4942_7105"
        x1="293.502"
        y1="136.671"
        x2="294.64"
        y2="147.884"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4942_7105"
        x1="68.4707"
        y1="233.537"
        x2="69.5707"
        y2="244.757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4942_7105"
        x1="184.736"
        y1="233.537"
        x2="185.836"
        y2="244.757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <clipPath id="clip0_4942_7105">
        <rect width="300" height="300" rx="5" fill="white" />
      </clipPath>
    </defs>
  </svg>
}
@if (assetKey === 'topShelfTv') {
  <svg
    class="responsive-svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4942_7169)">
      <rect width="300" height="300" rx="5" fill="white" />
      <rect
        x="18.875"
        y="18.875"
        width="500.249"
        height="316.249"
        rx="8.62498"
        [attr.fill]="assetMainColor || 'white'"
      />
      <rect
        x="18.875"
        y="18.875"
        width="500.249"
        height="316.249"
        rx="8.62498"
        fill="black"
        fill-opacity="0.2"
      />
      <rect
        x="18.875"
        y="18.875"
        width="500.249"
        height="316.249"
        rx="8.62498"
        stroke="url(#paint0_linear_4942_7169)"
        stroke-width="5.74999"
      />
      <!-- Add clipping path for the image -->
      <clipPath id="roundedTopShelfTvCorners">
        <rect x="43" y="43" width="320" height="100" rx="7.66665" />
      </clipPath>

      <!-- Add the image with proper dimensions and clipping -->
      <image
        [attr.xlink:href]="topShelfTvURL$ | async"
        x="42.5"
        y="42.5"
        width="321"
        height="101"
        preserveAspectRatio="xMidYMid slice"
        clip-path="url(#roundedTopShelfTvCorners)"
      />
      <rect
        x="42.832"
        y="164"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="55.8652"
        y="206.166"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint1_linear_4942_7169)"
      />
      <rect
        x="119.498"
        y="164"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="132.531"
        y="206.166"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint2_linear_4942_7169)"
      />
      <rect
        x="196.164"
        y="164"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="209.197"
        y="206.166"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint3_linear_4942_7169)"
      />
      <rect
        x="272.832"
        y="164"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="285.865"
        y="206.166"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint4_linear_4942_7169)"
      />
      <rect
        x="42.832"
        y="229.166"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="55.8652"
        y="271.331"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint5_linear_4942_7169)"
      />
      <rect
        x="119.498"
        y="229.166"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="132.531"
        y="271.33"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint6_linear_4942_7169)"
      />
      <rect
        x="196.164"
        y="229.166"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="209.197"
        y="271.33"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint7_linear_4942_7169)"
      />
      <rect
        x="272.832"
        y="229.166"
        width="65.1665"
        height="38.3332"
        rx="7.66665"
        fill="white"
      />
      <rect
        opacity="0.3"
        x="285.865"
        y="271.33"
        width="39.0999"
        height="3.83332"
        rx="1.91666"
        fill="url(#paint8_linear_4942_7169)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4942_7169"
        x1="16"
        y1="16"
        x2="307.693"
        y2="474.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4942_7169"
        x1="55.8652"
        y1="206.166"
        x2="56.6097"
        y2="213.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4942_7169"
        x1="132.531"
        y1="206.166"
        x2="133.276"
        y2="213.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4942_7169"
        x1="209.197"
        y1="206.166"
        x2="209.942"
        y2="213.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4942_7169"
        x1="285.865"
        y1="206.166"
        x2="286.61"
        y2="213.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_4942_7169"
        x1="55.8652"
        y1="271.331"
        x2="56.6097"
        y2="278.925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_4942_7169"
        x1="132.531"
        y1="271.33"
        x2="133.276"
        y2="278.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_4942_7169"
        x1="209.197"
        y1="271.33"
        x2="209.942"
        y2="278.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_4942_7169"
        x1="285.865"
        y1="271.33"
        x2="286.61"
        y2="278.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#474747" />
        <stop offset="1" stop-color="#252525" />
      </linearGradient>
      <clipPath id="clip0_4942_7169">
        <rect width="300" height="300" rx="5" fill="white" />
      </clipPath>
    </defs>
  </svg>
}
@if (assetKey === 'splashscreen') {
  <svg
    class="responsive-svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="300" height="300" rx="5" fill="white" />

    <path
      d="M113 19H187C187 25.6274 181.627 31 175 31H125C118.373 31 113 25.6274 113 19Z"
      fill="#252525"
    />

    <rect
      x="77.0742"
      y="18.5"
      width="145.85"
      height="263"
      rx="17.5"
      fill="#252525"
      stroke="#252525"
      stroke-width="5"
    />

    <!-- Add clipping path for the image that accounts for stroke width -->
    <clipPath id="roundedSplashscreenCorners">
      <rect x="79.5742" y="21" width="140.85" height="258" rx="15" />
    </clipPath>
    <!-- Add the image with the same adjusted dimensions -->
    <image
      [attr.xlink:href]="smartphoneURL$ | async"
      x="79.5742"
      y="21"
      width="140.85"
      height="258"
      preserveAspectRatio="xMidYMid slice"
      clip-path="url(#roundedSplashscreenCorners)"
    />
  </svg>
}
@if (assetKey === 'splashscreenLarge') {
  <svg
    class="responsive-svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="300" height="300" rx="5" fill="white" />
    <path
      d="M113 19H187C187 25.6274 181.627 31 175 31H125C118.373 31 113 25.6274 113 19Z"
      fill="#252525"
    />
    <rect
      x="90.5"
      y="18.5"
      width="119"
      height="263"
      rx="17.5"
      fill="#252525"
      stroke="#252525"
      stroke-width="5"
    />
    <!-- Add clipping path for the image that accounts for stroke width -->
    <clipPath id="roundedSplashscreenLargeCorners">
      <rect x="93" y="21" width="114" height="258" rx="15" />
    </clipPath>
    <!-- Add the image with the same adjusted dimensions -->
    <image
      [attr.xlink:href]="smartphoneLargeURL$ | async"
      x="93"
      y="21"
      width="114"
      height="258"
      preserveAspectRatio="xMidYMid slice"
      clip-path="url(#roundedSplashscreenLargeCorners)"
    />
  </svg>
}
@if (assetKey === 'splashscreenTv') {
  <svg
    class="responsive-svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="300" height="300" rx="5" fill="white" />
    <path
      d="M243.441 225.606L239.381 218.5L237.35 230.682"
      stroke="black"
      stroke-width="3.04545"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M56.6055 225.606L60.6661 218.5L62.6964 230.682"
      stroke="black"
      stroke-width="3.04545"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="18"
      y="71.3184"
      width="264"
      height="147"
      rx="8"
      fill="#252525"
      stroke="#252525"
      stroke-width="4"
    />
    <!-- Add clipping path for the image that accounts for stroke width -->
    <clipPath id="roundedSplashscreenTvCorners">
      <rect x="20" y="73.3184" width="260" height="143" rx="6" />
    </clipPath>

    <!-- Add the image with the same adjusted dimensions -->
    <image
      [attr.xlink:href]="tvSplashscreenURL$ | async"
      x="20"
      y="73.3184"
      width="260"
      height="143"
      preserveAspectRatio="xMidYMid slice"
      clip-path="url(#roundedSplashscreenTvCorners)"
    />
  </svg>
}
